import { useEffect, useState } from "react";
import axios from "axios";
import MainLayout from "./layouts/MainLayout";

function Dashboard() {

  const [user, setUser] = useState(null);

  useEffect(()=>{

    getProfile();

  },[]);

  const getProfile=async()=>{

    const token=localStorage.getItem("token");

    const response=await axios.get(
      "https://saleupcall.com/api/profile.php",
      {
        headers:{
          Authorization:`Bearer ${token}`
        }
      }
    );

    setUser(response.data.user);

  }

  return(

    <MainLayout>

      <h1>Dashboard</h1>

      {
        user && (

          <div>

            
            <p>Client ID : {localStorage.getItem("client_id")}</p>

            <p>User ID : {user.id}</p>

            <p>Email : {user.email}</p>

            <p>Role : {user.role_id}</p>

          </div>

        )
      }

    </MainLayout>

  );

}

export default Dashboard;